<template>
    <v-card color="primary" style="height: 100vh; margin-left: auto;margin-right: auto">
        <v-btn to="/" color="black" class="ma-4 primary--text">
            <v-icon>
                undo
            </v-icon>
        </v-btn>
        <v-card-text class="mt-12 mb-10">
            <br/><h1>Impressum</h1><br/>
            <p>Danny Weißhaupt<br />
                Kienhorststr. 164<br />13403 Berlin</p>
            <p>Telefon: +49 15115533708<br />
                E-Mail: contact@deutschdeluxe.com <br />
            </p>
            <p><strong>Verantwortlich für den Inhalt</strong> (gem. § 55 Abs. 2 RStV):<br />
                Danny Weißhaupt, Kienhorststr. 164 13403 Berlin
            </p>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "Imprint"
    }
</script>

<style scoped>

</style>
